import React from 'react';
import TreatmentConsentLandingPage from './TreatmentConsentLandingPage';

export default function VeneerConsentFormUk() {
  return (
    <TreatmentConsentLandingPage
      title="Veneer Consent Form UK | Cosmetic Dental Consent | Smile Consent"
      description="Build a veneer consent form for UK practices with AI-assisted drafting, digital signing, and clearer records for tooth preparation, longevity, risks, and alternatives."
      canonicalUrl="https://smileconsent.co.uk/veneer-consent-form-uk"
      h1="Veneer Consent Form for UK Practices"
      treatmentName="Veneer consent form"
      intro="Create veneer consent forms with clearer records for cosmetic expectations, tooth preparation, maintenance, and digital signing for UK dental teams."
      risks={[
        'Likely aesthetic outcome, shade matching limitations, and the importance of managing cosmetic expectations clearly.',
        'Material risks such as sensitivity, debonding, fracture, marginal issues, or the need for replacement over time.',
        'Whether tooth preparation is required and the long-term implications of elective cosmetic treatment.',
        'Alternatives such as whitening, orthodontics, composite bonding, crowns, or no treatment where relevant.',
        'Private costs, maintenance needs, and the possibility of future repair, replacement, or further restorative work.',
      ]}
      relatedLinks={[
        { title: 'Composite bonding consent form UK', description: 'Consent wording for minimally invasive cosmetic treatment', path: '/composite-bonding-consent-form-uk' },
        { title: 'Orthodontic consent form UK', description: 'Consent pages for aligners and braces', path: '/orthodontic-consent-form-uk' },
        { title: 'AI dental consent forms', description: 'See all treatment-specific consent workflows', path: '/dental-consent-forms' },
      ]}
    />
  );
}
